import { createFileRoute } from '@tanstack/react-router'

import { CheckinSignage } from '@/components/pages/Signage/CheckinSignage'

export const Route = createFileRoute('/_liff/signage/checkin')({
  component: CheckinSignage,
  staticData: {
    authRequired: false,
  },
})
